import type { BaseKeyFunction } from "../../../lib/types/baseKeyFunction";
import type { UseRequestParishSearchProps } from "./useRequestParishSearch";

export type KeyParishSearchProps = UseRequestParishSearchProps;

export const keyParishSearch: BaseKeyFunction<KeyParishSearchProps> = ({
  filters,
  search,
}) => ["search", filters, search];
